import { colors } from '../foundation';

type Props = {
  color?:
    | typeof colors.primary.red
    | typeof colors.primary.white
    | (typeof colors.black)[100]
    | (typeof colors.neutral)[10];
};

const Email = ({ color = colors.primary.red }: Props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <g id="icon">
          <path
            d="M6.6 6.55C6.35147 6.21863 5.88137 6.15147 5.55 6.4C5.21863 6.64853 5.15147 7.11863 5.4 7.45L8.2 11.1833C10.1 13.7167 13.9 13.7167 15.8 11.1833L18.6 7.45C18.8485 7.11863 18.7814 6.64853 18.45 6.4C18.1186 6.15147 17.6485 6.21863 17.4 6.55L14.6 10.2833C13.3 12.0167 10.7 12.0167 9.4 10.2833L6.6 6.55Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 4H6C3.79086 4 2 5.79086 2 8V16C2 18.2091 3.79086 20 6 20H18C20.2091 20 22 18.2091 22 16V8C22 5.79086 20.2091 4 18 4ZM6 5.5H18C19.3807 5.5 20.5 6.61929 20.5 8V16C20.5 17.3807 19.3807 18.5 18 18.5H6C4.61929 18.5 3.5 17.3807 3.5 16V8C3.5 6.61929 4.61929 5.5 6 5.5Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};
export default Email;
